export enum Permission {
  TRANSPORT_ORDERS_READ_ALL = 'TRANSPORT_ORDERS_READ_ALL',
  TRANSPORT_ORDERS_READ_ONE = 'TRANSPORT_ORDERS_READ_ONE',
  TRANSPORT_ORDERS_CREATE = 'TRANSPORT_ORDERS_CREATE',
  TRANSPORT_ORDERS_EDIT = 'TRANSPORT_ORDERS_EDIT',
  TRANSPORT_ORDERS_DELETE = 'TRANSPORT_ORDERS_DELETE',
  TRANSPORT_ORDERS_UPDATE_STATUS = 'TRANSPORT_ORDERS_UPDATE_STATUS',

  TRANSPORT_ORDERS_MANAGE_FILES = 'TRANSPORT_ORDERS_MANAGE_FILES',
  TRANSPORT_ORDERS_VIEW_FILES = 'TRANSPORT_ORDERS_VIEW_FILES',

  TRANSPORT_ORDERS_VIEW_FEED = 'TRANSPORT_ORDERS_VIEW_FEED',

  CONTRACTORS_READ_ALL = 'CONTRACTORS_READ_ALL',
  CONTRACTORS_READ_ONE = 'CONTRACTORS_READ_ONE',
  CONTRACTORS_CREATE = 'CONTRACTORS_CREATE',
  CONTRACTORS_EDIT = 'CONTRACTORS_EDIT',
  CONTRACTORS_DELETE = 'CONTRACTORS_DELETE',

  CONTRACTORS_MANAGE_FILES = 'CONTRACTORS_MANAGE_FILES',
  CONTRACTORS_VIEW_FILES = 'CONTRACTORS_VIEW_FILES',

  CLIENTS_READ_ALL = 'CLIENTS_READ_ALL',
  CLIENTS_READ_ONE = 'CLIENTS_READ_ONE',
  CLIENTS_CREATE = 'CLIENTS_CREATE',
  CLIENTS_EDIT = 'CLIENTS_EDIT',
  CLIENTS_DELETE = 'CLIENTS_DELETE',

  CLIENTS_MANAGE_FILES = 'CLIENTS_MANAGE_FILES',
  CLIENTS_VIEW_FILES = 'CLIENTS_VIEW_FILES',

  STATS_READ_ALL = 'STATS_READ_ALL',
  STATS_READ_OWN = 'STATS_READ_OWN',
  STATS_EXPORT = 'STATS_EXPORT',

  SETTINGS_VIEW = 'SETTINGS_VIEW',
  SETTINGS_EDIT = 'SETTINGS_EDIT',

  ADMIN_MANAGE_USERS = 'ADMIN_MANAGE_USERS',
  ADMIN_MANAGE_GROUPS = 'ADMIN_MANAGE_GROUPS',

  OWNER_ASSIGN_ADMIN = 'OWNER_ASSIGN_ADMIN',
}

export const GROUPED_PERMISSIONS = {
  TRANSPORT_ORDERS: {
    name: 'Uprawnienia zleceń',
    permissions: [
      { id: Permission.TRANSPORT_ORDERS_READ_ALL, label: 'Widzi wszystkie zlecenia' },
      { id: Permission.TRANSPORT_ORDERS_READ_ONE, label: 'Widzi szczegóły zlecenia' },
      { id: Permission.TRANSPORT_ORDERS_CREATE, label: 'Tworzy zlecenia' },
      { id: Permission.TRANSPORT_ORDERS_EDIT, label: 'Edytuje zlecenia' },
      { id: Permission.TRANSPORT_ORDERS_DELETE, label: 'Usuwa zlecenia' },
      { id: Permission.TRANSPORT_ORDERS_UPDATE_STATUS, label: 'Zmienia statusy zleceń' },
      { id: Permission.TRANSPORT_ORDERS_MANAGE_FILES, label: 'Zarządza plikami zleceń' },
      { id: Permission.TRANSPORT_ORDERS_VIEW_FILES, label: 'Widzi pliki zleceń' },
      { id: Permission.TRANSPORT_ORDERS_VIEW_FEED, label: 'Widzi zlecenia na stronie głównej' },
    ]
  },
  CONTRACTORS: {
    name: 'Uprawnienia podwykonawcy',
    permissions: [
      { id: Permission.CONTRACTORS_READ_ALL, label: 'Widzi wszystkich podwykonawców' },
      { id: Permission.CONTRACTORS_READ_ONE, label: 'Widzi szczegóły podwykonawcy' },
      { id: Permission.CONTRACTORS_CREATE, label: 'Tworzy podwykonawców' },
      { id: Permission.CONTRACTORS_EDIT, label: 'Edytuje podwykonawców' },
      { id: Permission.CONTRACTORS_DELETE, label: 'Usuwa podwykonawców' },
      { id: Permission.CONTRACTORS_MANAGE_FILES, label: 'Zarządza plikami podwykonawców' },
      { id: Permission.CONTRACTORS_VIEW_FILES, label: 'Widzi pliki podwykonawców' },
    ],
  },
  CLIENTS: {
    name: 'Uprawnienia klientów',
    permissions: [
      { id: Permission.CLIENTS_READ_ALL, label: 'Widzi wszystkich klientów' },
      { id: Permission.CLIENTS_READ_ONE, label: 'Widzi szczegóły klienta' },
      { id: Permission.CLIENTS_CREATE, label: 'Tworzy klientów' },
      { id: Permission.CLIENTS_EDIT, label: 'Edytuje klientów' },
      { id: Permission.CLIENTS_DELETE, label: 'Usuwa klientów' },
      { id: Permission.CLIENTS_MANAGE_FILES, label: 'Zarządza plikami klientów' },
      { id: Permission.CLIENTS_VIEW_FILES, label: 'Widzi pliki klientów' },
    ],
  },
  STATS: {
    name: 'Uprawnienia statystyk',
    permissions: [
      { id: Permission.STATS_READ_ALL, label: 'Widzi wszystkie statystyki' },
      { id: Permission.STATS_READ_OWN, label: 'Widzi własne statystyki' },
      { id: Permission.STATS_EXPORT, label: 'Eksportuje statystyki' },
    ],
  },
  SETTINGS: {
    name: 'Uprawnienia ustawień',
    permissions: [
      { id: Permission.SETTINGS_VIEW, label: 'Widzi ustawienia' },
      { id: Permission.SETTINGS_EDIT, label: 'Edytuje ustawienia' },
    ],
  },
  ADMIN: {
    name: 'Uprawnienia administratora',
    permissions: [
      { id: Permission.ADMIN_MANAGE_USERS, label: 'Zarządza użytkownikami' },
      { id: Permission.ADMIN_MANAGE_GROUPS, label: 'Zarządza grupami' },
    ],
  },
  OWNER: {
    name: 'Uprawnienia właściciela',
    permissions: [
      { id: Permission.OWNER_ASSIGN_ADMIN, label: 'Nadaje uprawnienia administratora' },
    ],
  },
};